import clickOutside from 'click-outside'

export default function uncheckOnClickOutside(page) {
  page.querySelectorAll('[data-uncheck-outside-click]').forEach(el => {
    clickOutside(el, () => {
      const checkbox = el.querySelector(`#${el.dataset.uncheckOutsideClick}`)

      if (checkbox.checked) {
        checkbox.checked = false
      }
    })
  })
}
